module.exports = __webpack_public_path__ + "img/nis-bg.999be7be.png";